import React, { useEffect, useState } from 'react';
import Chat from 'src/components/Chat/Chat';
import Adetails from './Adetails';
import UpdateAds from './UpdateAds';
import PropTypes from 'prop-types';
import AdsTracking from 'src/components/AdsTracking/AdsTracking';
import PaiementTracking from 'src/components/PaiementTracking/PaiementTracking';
import axios from "axios";
import ShopProductCard from './ProductCard';
import ProductCardMatching from './ProductCardMatching';
import { notifySuccess } from 'src/service/notificationService';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { updateAnnonce } from 'src/service/annonceApi';
import { useNotification } from 'src/contexts/NotificationContext';
import UpdateStockage from './UpdateStockage';
import { 
  Box, 
  Typography, 
  Avatar, 
  Chip, 
  IconButton, 
  Slide,
  Paper,
  Divider,
  Badge,
  Tooltip,
  useTheme,
  useMediaQuery,
  Modal,
  Backdrop
} from '@mui/material';
import {
  MessageRounded,
  EditRounded,
  InventoryRounded,
  PaymentRounded,
  LocalShippingRounded,
  CloseRounded,
  ArrowBackRounded,
  InfoRounded,
  ZoomInRounded
} from '@mui/icons-material';

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <div 
        className="h-full"
        style={{
          opacity: value === index ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          display: value === index ? 'block' : 'none'
        }}
      >
        {value === index && children}
      </div>
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const TabButton = ({ children, active, onClick, icon: Icon, badge, disabled, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  return (
    <Tooltip title={children} placement="top">
      {disabled ? (
        <span>
          <button
            onClick={undefined}
            disabled
            className={`
              relative flex flex-col items-center justify-center ${isMobile ? 'py-2 px-3' : 'py-4 px-3'} min-w-0 flex-1
              transition-all duration-200 ease-in-out
              text-gray-400 cursor-not-allowed
            `}
            style={{ height: isMobile ? '40px' : 'auto' }}
            {...props}
          >
            <Badge badgeContent={badge} color="error" invisible={!badge}>
              <Icon className={`${isMobile ? 'text-lg' : 'text-xl'} ${isMobile ? 'mb-0' : 'mb-1'} transition-transform duration-200`} />
            </Badge>
            {!isMobile && (
              <Typography 
                variant="caption" 
                className={`font-medium transition-all duration-200 text-gray-400`}
                sx={{ fontSize: '0.75rem' }}
              >
                {children}
              </Typography>
            )}
          </button>
        </span>
      ) : (
        <button
          onClick={onClick}
          className={`
            relative flex flex-col items-center justify-center ${isMobile ? 'py-2 px-3' : 'py-4 px-3'} min-w-0 flex-1
            transition-all duration-200 ease-in-out
            ${active 
              ? 'text-[#1b9098] border-b-2 border-[#1b9098] bg-[#1b9098]/5' 
              : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
            }
          `}
          style={{ height: isMobile ? '40px' : 'auto' }}
          {...props}
        >
          <Badge badgeContent={badge} color="error" invisible={!badge}>
            <Icon className={`${isMobile ? 'text-lg' : 'text-xl'} ${isMobile ? 'mb-0' : 'mb-1'} transition-transform duration-200 ${active ? 'scale-110' : ''}`} />
          </Badge>
          {!isMobile && (
            <Typography 
              variant="caption" 
              className={`font-medium transition-all duration-200 ${active ? 'font-semibold' : ''}`}
              sx={{ fontSize: '0.75rem' }}
            >
              {children}
            </Typography>
          )}
          {active && (
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-8 h-0.5 bg-[#1b9098]" />
          )}
        </button>
      )}
    </Tooltip>
  );
};

export default function AnnonceDetails({ selectedAnnonce, setSelectedAnnonce, categories, updateUserAds, onClose }) {
  const [value, setValue] = useState(0);
  const [selectedAnnonceStatus, setSelectedAnnonceStatus] = useState(selectedAnnonce.status);
  const { triggerRefresh } = useNotification();
  const [matchingData, setMatchingData] = useState(null);
  const [Loading, setLoading] = useState(true);
  const [noMatching, setNoMatching] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // JSON pour Postman - Structure complète de l'annonce
  

  // Vérifier les paramètres d'URL pour sélectionner l'onglet chat
  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab === 'chat') {
      setValue(0);
    }
  }, [searchParams]);

  function formatStringForHTTPRequest(inputString) {
    let stringWithoutSpaces = inputString.replace(/ /g, "%20");
    let stringWithoutAccents = stringWithoutSpaces.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return stringWithoutAccents;
  }

  useEffect(async () => {
    let annonceCategoryId = selectedAnnonce.category.id;
    let annonceAttributes = selectedAnnonce.annonceAttributes;

    let url = "";
    annonceAttributes.map(doc => {
      url += "&annonceAttributes.attribute%5B%5D=" + formatStringForHTTPRequest(doc.attribute);
    });

    annonceAttributes.map(doc => {
      url += "&annonceAttributes.attributeValue%5B%5D=" + formatStringForHTTPRequest(doc.attributeValue);
    });

    url += "&origin=TROUVE&category.id=" + annonceCategoryId + "&status=TROUVE";

    await axios.get(process.env.REACT_APP_PUBLIC_URL + '/api/annonces?status=TROUVE&professionalId=' + window.localStorage.getItem('customerId')).then(res => {
      if(res.data.length === 0) {
        setNoMatching(true);
      } else {
        const objets = res.data.filter(object => object.status === "TROUVÉ");
        setMatchingData(objets);
      }
    });
    
    setLoading(false);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNotifySuccess = () => {
    navigate('/dashboard/products/trouves');
  };

  const sendMessage = () => {
    notifySuccess('Email envoyé', handleNotifySuccess);
  };

  const handleUpdateAds = async () => {
    try {
      await updateAnnonce(selectedAnnonce.id, {status: "RESTITUÉ"}).then((res) => {
        notifySuccess('Objet restitué !', handleNotifySuccess);
        navigate('/dashboard/products/restitues');
        
        // Déclencher le rafraîchissement des notifications
        triggerRefresh();
      });
    } catch (error) {
      console.error(error);
    }
  };

  // Fonction pour obtenir l'URL de l'image
  const getImageUrl = (annonce) => {
    if (!annonce) return '';
    const baseUrl = process.env.REACT_APP_PUBLIC_URL;
    if (!annonce.filePath) {
      return `${baseUrl}/images/annonces/default/${annonce.category?.defaultImage}`;
    }
    return `${baseUrl}/images/annonces/${annonce.filePath}`;
  };

  // Fonction pour obtenir la couleur du statut
  const getStatusColor = (status) => {
    switch (status) {
      case 'TROUVÉ':
        return { bg: '#54D62C', text: '#ffffff' };
      case 'PERDU':
        return { bg: '#FFC107', text: '#212B36' };
      case 'RESTITUÉ':
        return { bg: '#3366FF', text: '#ffffff' };
      case 'ENVOYÉ':
        return { bg: '#8B5CF6', text: '#ffffff' };
              case 'A_EXPEDIER':
        return { bg: '#FF4842', text: '#ffffff' };
      case 'PAYÉ':
        return { bg: '#00AB55', text: '#ffffff' };
      default:
        return { bg: '#637381', text: '#ffffff' };
    }
  };

  const statusColor = getStatusColor(selectedAnnonce.status);

  // Composant Modal de détails pour mobile
  const DetailModal = () => (
    <Modal
      open={showDetailModal}
      onClose={() => setShowDetailModal(false)}
      BackdropComponent={Backdrop}
      BackdropProps={{
        sx: { backgroundColor: 'rgba(0, 0, 0, 0.8)' }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '500px',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          borderRadius: '12px',
          boxShadow: 24,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          opacity: showDetailModal ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
        }}
      >
        {/* Header de la modal */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 2,
            borderBottom: '1px solid #DFE3E8',
            backgroundColor: '#F8F9FA',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: '#212B36',
            }}
          >
            Détails de l'objet
          </Typography>
          <IconButton
            onClick={() => setShowDetailModal(false)}
            sx={{
              color: '#637381',
              '&:hover': {
                backgroundColor: '#F4F6F8',
              },
            }}
          >
            <CloseRounded />
          </IconButton>
        </Box>

        {/* Contenu de la modal */}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            backgroundColor: '#ffffff',
          }}
        >
          <Adetails annonce={selectedAnnonce} />
        </Box>
      </Box>
    </Modal>
  );

  // Mode mobile avec design TailAdmin
  if (isMobile) {
    return (
      <Slide direction="up" in={true} timeout={500}>
        <div className="w-full h-screen flex flex-col bg-gray-50">
          {/* Header TailAdmin */}
          <Box 
            sx={{ 
              backgroundColor: '#ffffff',
              padding: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: 3,
              borderBottom: '1px solid #DFE3E8',
            }}
          >
            <Tooltip 
              title="Voir les détails" 
              placement="top"
              arrow
            >
              <Avatar
                src={getImageUrl(selectedAnnonce)}
                alt={selectedAnnonce.title}
                onClick={() => setShowDetailModal(true)}
                sx={{ 
                  width: 56, 
                  height: 56,
                  borderRadius: '8px',
                  border: '1px solid #DFE3E8',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease-in-out',
                  position: 'relative',
                  '&:hover': {
                    transform: 'scale(1.02)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    border: '1px solid #1b9098',
                  },
                  '&:active': {
                    transform: 'scale(0.98)',
                  },
                  '&::before': {
                    content: '"ⓘ"',
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    fontSize: '12px',
                    color: '#637381',
                    opacity: 0.7,
                    transition: 'all 0.2s ease-in-out',
                  },
                  '&:hover::before': {
                    color: '#1b9098',
                    opacity: 1,
                  }
                }}
              />
            </Tooltip>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 700,
                  color: '#212B36',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {selectedAnnonce.title}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                <Chip 
                  label={selectedAnnonce.status} 
                  size="small" 
                  sx={{ 
                    backgroundColor: statusColor.bg,
                    color: statusColor.text,
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    height: '20px',
                  }} 
                />
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: '#637381',
                    fontWeight: 500,
                  }}
                >
                  #{selectedAnnonce.id}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Onglets TailAdmin */}
          <Box 
            sx={{ 
              backgroundColor: '#ffffff',
              borderBottom: '1px solid #DFE3E8',
            }}
          >
            <Box sx={{ display: 'flex', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
              <TabButton
                active={value === 0}
                onClick={() => handleChange(null, 0)}
                icon={MessageRounded}
                {...a11yProps(0)}
              >
                Discuter
              </TabButton>
              <TabButton
                active={value === 1}
                onClick={() => handleChange(null, 1)}
                icon={EditRounded}
                {...a11yProps(1)}
              >
                Modifier
              </TabButton>
              <TabButton
                active={value === 2}
                onClick={() => handleChange(null, 2)}
                icon={InventoryRounded}
                {...a11yProps(2)}
                disabled={true}
              >
                Stockage
              </TabButton>
              <TabButton
                active={value === 3}
                onClick={() => handleChange(null, 3)}
                icon={PaymentRounded}
                {...a11yProps(3)}
                disabled={true}
              >
                Paiement
              </TabButton>
              {selectedAnnonceStatus !== "TROUVÉ" && (
                <TabButton
                  active={value === 4}
                  onClick={() => handleChange(null, 4)}
                  icon={LocalShippingRounded}
                  {...a11yProps(4)}
                >
                  Livraison
                </TabButton>
              )}
            </Box>
          </Box>

          {/* Contenu */}
          <Box sx={{ flex: 1, overflow: 'hidden', backgroundColor: '#F9FAFB' }}>
            <CustomTabPanel value={value} index={0}>
              <Chat annonce={selectedAnnonce} onClose={onClose} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box sx={{ overflowY: 'auto', height: '100vh' }}>
                <UpdateAds 
                  selectedAnnonce={selectedAnnonce} 
                  setSelectedAnnonce={setSelectedAnnonce} 
                  categories={categories} 
                  updateUserAds={updateUserAds}
                />
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <UpdateStockage annonce={selectedAnnonce} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <PaiementTracking annonce={selectedAnnonce} />
            </CustomTabPanel>
            {selectedAnnonceStatus !== "TROUVÉ" && (
              <CustomTabPanel value={value} index={4}>
                <AdsTracking annonce={selectedAnnonce} />
              </CustomTabPanel>
            )}
          </Box>

          {/* Modal de détails */}
          <DetailModal />
        </div>
      </Slide>
    );
  }

  // Mode desktop avec design TailAdmin
  return (
    <div className="w-full h-full bg-gray-50">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 p-6 h-full">
          {/* Colonne de gauche - Photo et détails de l'objet */}
          <div className="lg:col-span-1">
            <Paper 
              elevation={0}
              sx={{ 
                height: '100%',
                borderRadius: '8px',
                backgroundColor: '#ffffff',
                border: '1px solid #DFE3E8',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* Détails de l'objet */}
              <Box sx={{ flex: 1 }}>
                <Adetails annonce={selectedAnnonce} />
              </Box>
            </Paper>
          </div>

          {/* Colonne de droite - Interface principale */}
          <div className="lg:col-span-3">
            <Paper 
              elevation={0}
              sx={{ 
                height: '100%',
                borderRadius: '8px',
                backgroundColor: '#ffffff',
                border: '1px solid #DFE3E8',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* Header TailAdmin */}
              <Box 
                sx={{ 
                  backgroundColor: '#ffffff',
                  padding: '20px 24px 0',
                  borderBottom: '1px solid #DFE3E8',
                }}
              >
                <Typography 
                  variant="h5" 
                  sx={{ 
                    color: '#212B36',
                    fontWeight: 700,
                    mb: 3,
                  }}
                >
                  Gestion de l'objet
                </Typography>
                
                {/* Onglets TailAdmin */}
                <Box sx={{ display: 'flex' }}>
                  <TabButton
                    active={value === 0}
                    onClick={() => handleChange(null, 0)}
                    icon={MessageRounded}
                    {...a11yProps(0)}
                  >
                    Discuter
                  </TabButton>
                  <TabButton
                    active={value === 1}
                    onClick={() => handleChange(null, 1)}
                    icon={EditRounded}
                    {...a11yProps(1)}
                  >
                    Modifier
                  </TabButton>
                  <TabButton
                    active={value === 2}
                    onClick={() => handleChange(null, 2)}
                    icon={InventoryRounded}
                    {...a11yProps(2)}
                    disabled={true}
                  >
                    Stockage
                  </TabButton>
                  <TabButton
                    active={value === 3}
                    onClick={() => handleChange(null, 3)}
                    icon={PaymentRounded}
                    {...a11yProps(3)}
                    disabled={true}
                  >
                    Suivi de paiement
                  </TabButton>
                  {selectedAnnonceStatus !== "TROUVÉ" && (
                    <TabButton
                      active={value === 4}
                      onClick={() => handleChange(null, 4)}
                      icon={LocalShippingRounded}
                      {...a11yProps(4)}
                    >
                      Suivi de livraison
                    </TabButton>
                  )}
                </Box>
              </Box>

              {/* Contenu principal */}
              <Box sx={{ flex: 1, overflow: 'hidden', backgroundColor: '#F9FAFB' }}>
                <CustomTabPanel value={value} index={0}>
                  <Chat annonce={selectedAnnonce} onClose={onClose} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <Box sx={{ overflowY: 'auto', height: '100vh' }}>
                    <UpdateAds 
                      selectedAnnonce={selectedAnnonce} 
                      setSelectedAnnonce={setSelectedAnnonce} 
                      categories={categories} 
                      updateUserAds={updateUserAds}
                    />
                  </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <UpdateStockage annonce={selectedAnnonce} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                  <PaiementTracking annonce={selectedAnnonce} />
                </CustomTabPanel>
                {selectedAnnonceStatus !== "TROUVÉ" && (
                  <CustomTabPanel value={value} index={4}>
                    <AdsTracking annonce={selectedAnnonce} />
                  </CustomTabPanel>
                )}
              </Box>
            </Paper>
          </div>
        </div>

        {/* Modal de détails pour desktop aussi (optionnel) */}
        <DetailModal />
      </div>
    );
}
